import { createReducer, on } from '@ngrx/store';
import { ProductContextActions } from './product-context.actions';
import { ProductContextState, initialState } from './product-context.state';

export const reducer = createReducer(
  initialState,
  on(
    ProductContextActions.set_context,
    (state, data): ProductContextState => ({
      ...state,
      context: data.context
    })
  )
);
